<script setup></script>

<template>
  <Transition name="fade">
    <div class="shell" @click.self="$emit('close')">
      <div class="modal">
        <div class="caption">
          <!-- <img src="@/assets/9may/hero/WhiteLogo.svg" alt="" class="caption__img"> -->
          <p class="title">О МетаВДНХ</p>
          <button class="close" @click="$emit('close')">
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.4121 22.9983L13.3262 31.0842L14.9144 32.6725L23.0004 24.5866L31.0862 32.6725L32.6745 31.0842L24.5885 22.9983L32.6745 14.9125L31.0862 13.3242L23.0004 21.4101L14.9144 13.3242L13.3262 14.9125L21.4121 22.9983Z"
                fill="#ffffff" />
            </svg>
          </button>
        </div>
        <p class="subtitle">
          МетаВДНХ — уникальный проект, в котором любой желающий может
          отправиться на виртуальную прогулку по главной выставке страны,
          изучить экспозиции павильонов и даже отправиться на экскурсию в
          прошлое.
        </p>
        <p class="subtext">
          Это первая метавселенная Москвы, созданная на базе Цифрового двойника
          города, а ее запуск в 2024 году был приурочен к 85-летию выставки.
        </p>
        <img src="@/assets/about.png" alt="" class="about__img" />
        <p class="subtitle-second">В МетаВДНХ уже доступны:</p>
        <ul class="list">
          <li class="list-element">
            Прогулка по главной выставке страны пешком или на самокате.
            Полюбуйтесь фонтанами и павильонами, рассмотрите экспонаты
            павильонов «Космос» и «Центральный» и пообщайтесь с другими гостями
          </li>
          <li class="list-element">
            Виртуальная экскурсия в компании цифрового двойника артиста Вани
            Дмитриенко. Изучите историю ВДНХ: побывайте в космосе, посмотрите в
            ядерный реактор и загляните на съемочную площадку.
          </li>
          <li class="list-element">
            Виртуальное путешествие по павильонам международной выставки-форума
            «Россия». Познакомьтесь с экспозициями легендарной выставки из любой
            точки страны
          </li>
          <li class="list-element">
            Уникальный спецпроект к 80-летию Победы: посмотрите кинохроники
            Победы в Зеленом театре.
          </li>
        </ul>
        <button class="link" @click.self="$emit('close')">Закрыть</button>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.shell {
  background: rgba(38, 38, 38, 0.7);
  z-index: 1000000;
  padding: 5.5rem 1rem;
  @media (max-width: 1000px) {
    padding: 3.5rem 1rem;
  }
}

.modal {
  padding: 0;
  max-width: 1344px;
  border-radius: 56px;
  pointer-events: all;
  background: #00288c;
  padding: 40px 72px;
  width: 100%;

  &-content {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
  }
  @media (max-width: 1000px) {
    padding: 24px 16px;
    border-radius: 24px;
  }
}

.title {
  font-weight: 500;
  font-size: 64px;
  line-height: 130%;
  letter-spacing: 0.01em;
  color: #fff;
}
.subtitle {
  margin-top: 47px;
  font-weight: 700;
  font-size: 48px;
  line-height: 100%;

  color: #fff;
  &-second {
    margin-top: 40px;
    font-size: 32px;
    line-height: 125%;
    color: #fff;
    font-weight: 700;
  }
  @media (max-width: 1000px) {
    margin-top: 16px;
    font-size: 20px;
    line-height: 130%;
    &-second {
      margin-top: 16px;
      font-size: 16px;
    }
  }
}
.subtext {
  margin-top: 32px;
  font-weight: 700;
  font-size: 32px;
  line-height: 125%;
  color: #fff;
  @media (max-width: 1000px) {
    margin-top: 16px;
    font-size: 18px;
  }
}
.list {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: disc;
  &-element {
    font-weight: 400;
    font-size: 24px;
    line-height: 133%;
    color: #fff;
    margin-left: 35px;
    padding-left: 5px;
  }
  @media (max-width: 1000px) {
    margin-top: 12px;
    gap: 6px;
    &-element {
      font-size: 16px;
      color: #fff;
      margin-left: 12px;
      padding-left: 3px;
    }
  }
}
.text {
  margin-top: 20px;
  font-weight: 400;
  font-size: 24px;
  line-height: 133%;
  color: #fff;
  font-weight: 700;
  @media (max-width: 1422px) {
    br {
      display: none;
    }
  }
}

.caption {
  display: flex;
  align-items: center;
  gap: 16px;
}

.close {
  margin-left: auto;
  display: flex;
  background: none;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;

  &:hover {
    opacity: 0.5;
  }

  img {
    width: 100%;
  }
  @media (max-width: 1000px) {
    width: 32px;
    height: 32px;
  }
}
.about__img {
  margin-top: 40px;
  border-radius: 32px;
  @media (max-width: 1000px) {
    margin-top: 24px;
    border-radius: 24px;
  }
}
.link {
  margin-top: 24px;
  justify-content: center;
  font-size: 16px;
  @media (max-width: 1000px) {
    padding: 0.8125rem 1.25rem;
    font-size: 14px;
    line-height: 140%;
    gap: 0.5rem;
  }
}
@media (max-width: 1300px) {
  .title {
    font-size: 20px;
  }
  .text {
    font-size: 16px;
  }
}
</style>
